<form [formGroup]="realtorAgentForm">
  <div class="row">
    <div class="col-lg-6 mb-3">
      <input-field
        [label]="'Base Commission Percentage'"
        [type]="'number'"
        [placeholder]="'Enter Base Commission Percentage'"
        formControlName="baseCommissionPercentage"
        [min]="0"
        [max]="100"
      >
      </input-field>
    </div>
    <div class="col-lg-6 mb-3">
      <currency-input-field
        [label]="'Base Commission Amount'"
        [placeholder]="'Enter Base Commission Amount'"
        formControlName="baseCommissionAmount"
        [control]="realtorAgentForm.get('baseCommissionAmount')"
        [min]="0"
      >
      </currency-input-field>
    </div>
    <div class="col-lg-6 mb-3">
      <input-field
        [label]="'Option Commission Percentage'"
        [type]="'number'"
        [placeholder]="'Enter Option Commission Percentage'"
        formControlName="optionCommissionPercentage"
        [min]="0"
        [max]="100"
      >
      </input-field>
    </div>
    <div class="col-lg-6 mb-3">
      <currency-input-field
        [label]="'Option Commission Amount'"
        [placeholder]="'Enter Option Commission Amount'"
        formControlName="optionCommissionAmount"
        [control]="realtorAgentForm.get('optionCommissionAmount')"
        [min]="0"
      >
      </currency-input-field>
      @if (
        realtorAgentForm.get('optionCommissionAmount')?.touched &&
        realtorAgentForm.get('optionCommissionAmount')?.hasError('required')
      ) {
        <small class="text-danger">Option Commission Amount is required</small>
      }
      @if (
        realtorAgentForm.get('optionCommissionAmount')?.touched &&
        realtorAgentForm.get('optionCommissionAmount')?.hasError('min')
      ) {
        <small class="text-danger">Option Commission Amount must be a positive value</small>
      }
    </div>
    <div class="col-lg-6 mb-3">
      <label class="form-label">Notes</label>
      <textarea class="form-control" [placeholder]="'Enter Notes'" formControlName="notes" rows="3"></textarea>
    </div>
    <div class="w-100"></div>
    <div class="col-lg-6 mb-3">
      <p class="me-2 mb-0 fs-14">Allow Commission On Base</p>
      <p-toggleswitch formControlName="allowCommissionOnBase" />
    </div>
    <div class="col-lg-6 mb-3">
      <p class="me-2 mb-0 fs-14">Allow Commission On Option</p>
      <p-toggleswitch formControlName="allowCommissionOnOption" />
    </div>
    <div class="col-lg-6 mb-3">
      <p class="me-2 mb-0 fs-14">Include In Contract</p>
      <p-toggleswitch formControlName="includeInContract" />
    </div>
  </div>
</form>
